import { z } from "zod";

const findIdItemSchema = z.object({
  personName: z.string().optional(),
  pccafeAccount: z.string(),
});

export type FindIdItemType = z.infer<typeof findIdItemSchema>;

export const findIdResponseSchema = z.object({
  isSelfCert: z.enum(["Y", "N"]).optional(),
  personName: z.string().optional(),
  idList: z.array(findIdItemSchema).optional(),
});

export type FindIdResponseType = z.infer<typeof findIdResponseSchema>;
